import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, Phone } from "lucide-react";

const TEAM_IMG =
  "https://images.pexels.com/photos/6805161/pexels-photo-6805161.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export const CTASection = ({ onCTA }) => {
  return (
    <section
      id="cta"
      className="relative py-20 md:py-28 overflow-hidden"
      data-testid="cta-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="relative rounded-[2rem] overflow-hidden border border-border"
          data-testid="cta-card"
        >
          {/* BG image */}
          <img
            src={TEAM_IMG}
            alt=""
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#050505]/95 via-[#0a0a0a]/85 to-[#0a0a0a]/40" />
          <div className="absolute -top-40 -right-40 h-[28rem] w-[28rem] rounded-full bg-[#FF7A00]/40 blur-[140px]" />
          <div className="absolute -bottom-40 -left-40 h-[28rem] w-[28rem] rounded-full bg-[#00C853]/30 blur-[140px]" />

          <div className="relative px-7 md:px-14 py-14 md:py-20 grid md:grid-cols-12 gap-10 items-center text-white">
            <div className="md:col-span-8 space-y-6">
              <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/10 border border-white/20 text-xs font-semibold tracking-[0.2em] uppercase">
                <span className="h-1.5 w-1.5 rounded-full bg-[#00C853]" />
                Built for Bharat · Live in 48h
              </div>
              <h2
                className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[0.98]"
                data-testid="cta-heading"
              >
                Your offline shop.
                <br />
                <span className="text-gradient-saffron">A digital empire.</span>
                <br />
                <span className="text-white/70">In one weekend.</span>
              </h2>
              <p className="text-base md:text-lg text-white/70 max-w-xl">
                Stop watching customers scroll past you. Let&apos;s build the
                website, app and AI bot that finally puts your business on the
                Indian internet.
              </p>
            </div>

            <div className="md:col-span-4 flex flex-col gap-4 md:items-end">
              <button
                onClick={onCTA}
                className="group inline-flex items-center justify-center gap-3 h-14 px-7 rounded-full gradient-saffron text-white font-semibold text-base shadow-[0_12px_40px_rgba(255,122,0,0.5)] hover:shadow-[0_18px_60px_rgba(255,122,0,0.7)] hover:-translate-y-0.5 transition-all w-full md:w-auto"
                data-testid="cta-primary-button"
              >
                Start my 48-hour build
                <ArrowRight className="h-4 w-4 group-hover:translate-x-0.5 transition-transform" />
              </button>
              <a
                href="tel:+919999999999"
                className="inline-flex items-center justify-center gap-2 h-12 px-5 rounded-full bg-white/10 hover:bg-white/15 border border-white/20 text-white font-semibold text-sm w-full md:w-auto transition-colors"
                data-testid="cta-secondary-button"
              >
                <Phone className="h-4 w-4" />
                Talk to a founder
              </a>
              <div className="text-[11px] text-white/50 tracking-wider md:text-right">
                No setup fee · Pay only when live
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;
